export default __webpack_public_path__ + "static/media/information--bus-stop--g2.81775f9e.png";